import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import ContactModal from "../../components/ContactModal";

function Block22() {

    return (
            <section className="about-section-two style-two layout-pt-60 layout-pb-60 js-tab-menu-content" style={{background: "#F5F9FE"}}>
                <div className="auto-container">
                    <div className="row grid-base align-items-center">
                        <div className="image-column -no-margin col-xl-5 col-lg-6 col-md-12 col-sm-12 wow fadeInRight">
                            <figure className="image-box image-responsive">
                                <img src="/images/resource/bureau2.webp" alt="bureau2" className="homepage"/>
                            </figure>
                        </div>

                        <div className="content-column col-xl-6 offset-xl-2 col-lg-5 offset-lg-1 col-md-12 col-sm-12">
                            <div className="wow fadeInLeft">
                                <div className="sec-title">
                                    <h2 className="fw-700"><span>Des résultats concrets </span>pour vos équipes</h2>
                                </div>
                                <div className="text">
                                    Ces webinaires sont pensés pour transformer la sensibilisation en actions concrètes.
                                    Ils permettent de renforcer l’engagement des équipes et d’accompagner les managers au quotidien.

                                    <ul className="list-style-two homepage">
                                        <li>Sensibiliser vos collaborateurs et en faire des acteurs de l’inclusion</li>
                                        <li>Renforcer votre politique handicap et concrétiser votre engagement</li>
                                        <li>Diffuser une culture commune autour du handicap, de la diversité et de l’inclusion</li>
                                        <li>Donner des repères concrets et actionnables aux managers et aux équipes</li>
                                    </ul>
                                </div>

                                {/*<motion.button
                                        className="theme-btn btn-style-one small"
                                        initial={{opacity: 0, y: 0}}
                                        animate={{opacity: 1, y: 20}}
                                        transition={{delay: 1.0, duration: 1.5}}
                                        data-cal-namespace="ligne-inclusion"
                                        data-cal-link="team/talents-handicap/ligne-inclusion"
                                        data-cal-config='{"layout":"month_view"}'
                                >Réserver un créneau
                                </motion.button>*/}

                                <ContactModal textButton="Planifier un échange" showText={false} small="small"
                                              linkPageContact={false} iframe={false} couleur={false} formModal={true}/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    )
}

export default Block22;
